<!-- <ion-header>
	<ion-icon class="back-button" size="large" (click)="home()" src="../../../assets/icon/back-button.svg" aria-label="Back" role="img"></ion-icon>
	<div role="region" aria-label="Content section">
		<ion-img class="brand-logo" size="large" src="/assets/losteria/logo.svg" alt="L'Osteria logo"></ion-img>
	</div>

	<div class="menu-wrapper" role="region" aria-label="Menu container">
		<app-burger-btn></app-burger-btn>
	</div>
</ion-header> -->
<ion-content>
	<ion-row
		*ngIf="verifiedOrder &&	 verifiedOrder?.isPayed"
		class="ion-justify-content-center"
		role="region"
		aria-label="Verified and paid order row"
	>
		<ion-col sizeLg="7" size="0" class="ion-no-padding container-all">
			<div class="wrapper-left">
				<ion-img src="../../../assets/dean_and_david/home_big_payment.jpg" alt=""></ion-img>
			</div>
		</ion-col>
		<ion-col class="ion-padding wrapper-info container-all" size="12" size-lg="5">
			<ion-row role="region" aria-label="Content section">
				<ion-col class="ion-no-padding">
					<div *ngIf="isAndroid()" role="region">
						<div class="mobile-section" role="region" aria-label="Mobile section">
							If you want to open in mobile click this link
							<a
								[href]="'deananddavid://dean-and-david.smoothr.de/payment/success/' + paymentData?._id + '?order='+verifiedOrder?._id"
								role="link"
								>Link</a
							>
						</div>
					</div>

					<h3 class="header-title">{{"payment_success_page.thank_text"| translate}}</h3>
					<div
						class="delivery-options"
						*ngIf="verifiedOrder?.preorder?.type === pt.DELIVERY"
						role="region"
						aria-label="Delivery options section"
					>
						<div class="header-sliders">
							<div class="step" role="region" aria-label="Step container">
								<div
									class="line"
									[class.selected]="verifiedOrder.status == orderStatusEnum.IN_PREPARATION || verifiedOrder.status == orderStatusEnum.READY || verifiedOrder.status == orderStatusEnum.DONE"
									role="region"
									aria-label="Order status line"
								></div>
								<p>In Progress</p>
							</div>
							<div class="step" role="region" aria-label="Step information">
								<div
									class="line"
									[class.selected]="verifiedOrder.status == orderStatusEnum.READY  || verifiedOrder.status == orderStatusEnum.DONE"
									role="region"
									aria-label="Order status line"
								></div>
								<p>Pick up</p>
							</div>
							<div class="step" role="region" aria-label="Step content">
								<div
									class="line"
									[class.selected]="( verifiedOrder.status == orderStatusEnum.READY  || verifiedOrder.status == orderStatusEnum.DONE )&& driverDispatch"
									role="region"
									aria-label="Order line"
								></div>
								<p>Delivery</p>
							</div>
						</div>
						<div class="delivery-steps" role="region" aria-label="Delivery steps">
							<div
								class="delivery-steps__item"
								*ngIf="verifiedOrder.status == orderStatusEnum.IN_PREPARATION"
								role="region"
								aria-label="Delivery steps item"
							>
								<p>estimated arrival time</p>
								<h5>{{mapTime(verifiedOrder?.estimatedAt, verifiedOrder?.asap)}}</h5>
								<ion-icon
									src="../../../assets/dean_and_david/delivery/in_preparation.svg"
									role="img"
									aria-label="In preparation icon"
								></ion-icon>
								<h3>Your order is in Preparation</h3>
							</div>
							<div
								class="delivery-steps__item"
								*ngIf="verifiedOrder.status == orderStatusEnum.READY && !driverDispatch  && !verifiedOrder?.dispatch?.stopsUntilDestination"
								role="region"
								aria-label="Delivery step item"
							>
								<p>estimated arrival time</p>
								<h5>
									{{verifiedOrder?.estimatedAt ?mapTime(verifiedOrder?.estimatedAt, verifiedOrder?.asap) :
									mapTime(verifiedOrder?.orderAt, verifiedOrder?.asap)}}
								</h5>
								<ion-icon
									src="../../../assets/dean_and_david/delivery/pick_up.svg"
									role="img"
									aria-label="Pick up icon"
								></ion-icon>
								<h3>A courier picks up your order</h3>
							</div>
							<div
								class="delivery-steps__item"
								*ngIf="verifiedOrder.status == orderStatusEnum.READY && !driverDispatch && verifiedOrder?.dispatch?.stopsUntilDestination > 0"
								role="region"
								aria-label="Delivery step item"
							>
								<p>estimated arrival time</p>
								<h5>
									{{verifiedOrder?.estimatedAt ?mapTime(verifiedOrder?.estimatedAt) : mapTime(verifiedOrder?.orderAt,
									verifiedOrder?.asap)}}
								</h5>
								<ion-icon
									src="../../../assets/dean_and_david/delivery/pick_up.svg"
									role="img"
									aria-label="Pickup icon"
								></ion-icon>
								<h3>
									A courier delivering previous order.<br />
									Your queue: {{verifiedOrder?.dispatch?.stopsUntilDestination}}
								</h3>
							</div>
							<!-- <div class="delivery-steps__item" role="region" aria-label="Delivery step">
								<p>
									Courier arrived
								</p>
								<h5>
									14:40
								</h5>
								<ion-icon
									src="../../../assets/dean_and_david/delivery/arrived.svg" role="img"></ion-icon>
								<h3>Order Arrived</h3>
							</div> -->
							<div
								class="delivery-steps__item map-block"
								[class.hide-item]="verifiedOrder.status == orderStatusEnum.READY && driverDispatch &&( !verifiedOrder?.preorder?.deliveryStatus || verifiedOrder?.preorder?.deliveryStatus !== deliveryStatusEnum.ARRIVED) "
								role="region"
								aria-label="Delivery steps item"
							>
								<div class="map-container" role="region" aria-label="Map container">
									<div class="map-frame" role="region" aria-label="Map display area">
										<div id="map-item" class="black-white-map" role="region" aria-label="Map item"></div>
									</div>
								</div>
								<div class="status-show" role="region" aria-label="Status information">On the way</div>

								<div class="show-time">
									Courier will arrive {{estimatedNewTime ? mapTime(estimatedNewTime): ( verifiedOrder?.estimatedAt?
									mapTime(verifiedOrder?.estimatedAt) : null)}}
								</div>
							</div>
							<div
								class="delivery-steps__item"
								*ngIf="(verifiedOrder.status == orderStatusEnum.READY) && driverDispatch && verifiedOrder?.preorder?.deliveryStatus  && verifiedOrder?.preorder?.deliveryStatus == deliveryStatusEnum.ARRIVED "
								role="region"
								aria-label="Delivery step: order ready and driver arrived"
							>
								<p>Courier arrived</p>
								<h5>{{mapTime(verifiedOrder?.updatedAt)}}</h5>
								<ion-icon
									src="../../../assets/dean_and_david/delivered.svg"
									role="img"
									aria-label="Delivered icon"
								></ion-icon>
								<h3>Order arrived</h3>
							</div>
							<div
								class="delivery-steps__item"
								*ngIf="verifiedOrder.status == orderStatusEnum.DONE"
								role="region"
								aria-label="Delivery step item"
							>
								<p>Courier arrived</p>
								<h5>{{mapTime(verifiedOrder?.finishedAt)}}</h5>
								<ion-icon src="../../../assets/dean_and_david/delivery/done.svg" role="img" aria-label="Done"></ion-icon>
								<h3>Order Delivered</h3>
							</div>
						</div>
					</div>

					<ion-card
						class="verification-code"
						*ngIf="verifiedOrder?.deliveryVerificationCode && (verifiedOrder.status === orderStatusEnum.IN_PREPARATION || verifiedOrder.status === orderStatusEnum.READY)"
					>
						<ion-row><ion-col>{{'order.verification_title' | translate}}</ion-col></ion-row>
						<ion-row><ion-col>{{'order.verification_desc' | translate}}</ion-col></ion-row>
						<div>{{verifiedOrder.deliveryVerificationCode}}</div>
					</ion-card>

					<ion-card>
						<ion-card-content>
							<ion-row class="title-section" role="region" aria-label="Title section">
								<ion-col size="12">
									<h3>Übersicht</h3>
								</ion-col>
							</ion-row>
						</ion-card-content>
						<ion-card-content>
							<ion-row role="region" aria-label="Content section">
								<ion-col class="left-col"> {{ 'payment_success_page.order_number' | translate }} </ion-col>
								<ion-col class="right-col"><b>{{verifiedOrder.code}} </b> </ion-col>
							</ion-row>

							<ion-row role="region" aria-label="Informative content">
								<ion-col class="left-col"> {{ 'payment_success_page.order_type' | translate }} </ion-col>
								<ion-col class="right-col"> {{'preorder_type.' + verifiedOrder.preorder.type | translate}} </ion-col>
							</ion-row>

							<ion-row *ngIf="!verifiedOrder.asap" role="region" aria-label="Order verification row">
								<ion-col class="left-col"> {{ 'payment_success_page.date_date' | translate }} </ion-col>
								<ion-col class="right-col">
									<ng-container *ngIf="verifiedOrder.asap">
										{{'checkout_modal.first_slot' | translate }} @if(this.orderVenue?.slot?.active &&
										this.orderVenue?.slot?.readyOffset){
										({{moment(verifiedOrder.createdAt).add(this.orderVenue?.slot?.readyOffset, 'm').format('HH:mm')}})
										}@else { ({{moment(verifiedOrder.createdAt).add(10, 'm').format('HH:mm')}}) }
									</ng-container>
									<ng-container *ngIf="!verifiedOrder.asap && verifiedOrder.orderAt">
										{{moment(verifiedOrder.orderAt).format('DD.MM.yyyy')}}
									</ng-container>
								</ion-col>
							</ion-row>

							<ion-row role="region" aria-label="Content section">
								<ion-col class="left-col"> {{ 'payment_success_page.date_time' | translate }} </ion-col>
								<ion-col class="right-col">
									<ng-container *ngIf="verifiedOrder.asap">
										{{'checkout_modal.first_slot' | translate }} @if(this.orderVenue?.slot?.active &&
										this.orderVenue?.slot?.readyOffset){
										({{moment(verifiedOrder.createdAt).add(this.orderVenue?.slot?.readyOffset, 'm').format('HH:mm')}})
										}@else { ({{moment(verifiedOrder.createdAt).add(10, 'm').format('HH:mm')}}) }
									</ng-container>
									<ng-container *ngIf="!verifiedOrder.asap && verifiedOrder.orderAt">
										{{moment(verifiedOrder.orderAt).format('HH:mm')}}
									</ng-container>
								</ion-col>
							</ion-row>
							<ion-row *ngIf="orderVenue" role="region" aria-label="Order venue details">
								<ion-col class="left-col">{{'payment_success_page.title_restaurant' | translate}} </ion-col>
								<ion-col class="right-col">{{orderVenue?.name}}</ion-col>
							</ion-row>
							<ion-row *ngIf="orderVenue" role="region" aria-label="Order venue information">
								<ion-col class="left-col">{{'payment_success_page.title_restaurant_info' | translate}} </ion-col>
								<ion-col class="right-col"
									>{{orderVenue?.street}} {{orderVenue?.number}}, {{orderVenue?.postalCode}}
									{{orderVenue?.city?.de}}</ion-col
								>
							</ion-row>
							<ion-row role="region" aria-label="Content row">
								<ion-col class="left-col"> {{ 'payment_success_page.name' | translate }} </ion-col>
								<ion-col class="right-col"> {{verifiedOrder.preorder.name}} </ion-col>
							</ion-row>

							<ion-row>
								<ion-col class="left-col"> {{ 'payment_success_page.email' | translate }} </ion-col>
								<ion-col class="right-col"> {{verifiedOrder.preorder.email}} </ion-col>
							</ion-row>

							<ion-row>
								<ion-col class="left-col"> {{ 'payment_success_page.phone' | translate }} </ion-col>
								<ion-col class="right-col">{{verifiedOrder.preorder.phone}}</ion-col>
							</ion-row>
						</ion-card-content>

						<ion-card-content>
							<ion-row *ngFor="let oa of verifiedOrder.orderedArticles">
								<ion-col class="left-col" size="8"> {{oa.quantity}}x {{oa.article.name | langObservable| async }} </ion-col>
								<ion-col class="right-col" size="4">
									{{numberToCurrency(OrderUtils.totalPrice(oa, verifiedOrder.type, verifiedOrder.preorder.type),
									verifiedOrder.currency)}}
								</ion-col>
								<ion-col size="12">
									<ion-row *ngFor="let option of oa.groups">
										<ion-col class="option-name ion-no-padding">
											{{option.article.name | langObservable| async }}
											<ng-container *ngIf="option.article?.price">
												{{ numberToCurrency(option.article?.price, verifiedOrder.currency) }}
											</ng-container>
										</ion-col>
									</ion-row>
								</ion-col>
							</ion-row>
							<ion-row *ngIf="promoCode" role="region" aria-label="Promocode information">
								<ion-col size="12" class="left-col"> Promocode: {{promoCode?.name}} </ion-col>
							</ion-row>
							<ion-row
								*ngIf="verifiedOrder.preorder.note && verifiedOrder.preorder.note.length > 0"
								role="region"
								aria-label="Order note section"
							>
								<ion-col>
									<b>{{ 'payment_success_page.note' | translate }}</b>
								</ion-col>
								<ion-col>{{verifiedOrder.preorder.note}}</ion-col>
							</ion-row>
							<ion-row
								*ngIf="verifiedOrder?.subsidy && verifiedOrder?.preorder?.type === pt.FOOD_SPOT"
								role="region"
								aria-label="Order details"
							>
								<ion-col class="left-col"> {{ 'menu_page.subsidy' | translate }} </ion-col>
								<ion-col class="right-col">
									-{{numberToCurrency(numberD(verifiedOrder?.subsidy),verifiedOrder?.currency)}}
								</ion-col>
							</ion-row>
						</ion-card-content>
						<ion-card-content *ngIf="verifiedOrder?.preorder?.deliveryFee && numberD(verifiedOrder?.preorder?.deliveryFee) > 0">
							<ion-row class="price-title" role="region" aria-label="Price title container">
								<ion-col class="left-col"> {{ 'payment_success_page.delivery_fee' | translate }} </ion-col>
								<ion-col class="right-col bold">
									+{{numberToCurrency(numberD(verifiedOrder?.preorder?.deliveryFee), verifiedOrder.currency)}}
								</ion-col>
							</ion-row>
						</ion-card-content>
						<ion-card-content *ngIf="paymentData?.tip && numberD(paymentData?.tip) > 0">
							<ion-row class="price-title">
								<ion-col class="left-col"> {{ 'checkout_modal.tip' | translate }} </ion-col>
								<ion-col class="right-col bold">
									+{{numberToCurrency(numberD(paymentData?.tip), verifiedOrder.currency)}}
								</ion-col>
							</ion-row>
						</ion-card-content>
						<ion-card-content>
							<ion-row class="price-title" role="region" aria-label="Price title">
								<ion-col class="left-col"> {{ 'payment_success_page.summary' | translate }} </ion-col>
								<ion-col class="right-col bold">
									<ng-container *ngIf="paymentData">
										{{numberToCurrency(numberD(paymentData.totalSum), verifiedOrder.currency)}}
									</ng-container>
									<ng-container *ngIf="!paymentData">
										{{OrderUtils.formattedOrderTotalPrice(verifiedOrder, true, true)}}
									</ng-container>
								</ion-col>
							</ion-row>
						</ion-card-content>
					</ion-card>
				</ion-col>
			</ion-row>
			<ion-row>
				<ion-button class expand="block" (click)="home()">
					<ng-container *ngIf="error"> {{ 'payment_success_page.reload' | translate }} {{error}} </ng-container>
					<ng-container *ngIf="!error">{{ 'payment_success_page.back_home' | translate }}</ng-container>
					<ion-spinner *ngIf="loading" name="crescent"></ion-spinner>
				</ion-button>
			</ion-row>
		</ion-col>
	</ion-row>
</ion-content>
